import type { SVGProps } from 'react';
const SvgIconShare = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={27} height={26} {...props}>
    <path
      fill="#1A202C"
      d="M14.5 6.419v2.58h6a1 1 0 0 1 1 1.001v12a1 1 0 0 1-1 1h-14a1 1 0 0 1-1-1V10a1 1 0 0 1 1-1h6V6.416l-1.13 1.129a.993.993 0 0 1-1.407-.007 1 1 0 0 1-.007-1.407l2.842-2.841a1 1 0 0 1 .697-.29l.008.004c.254 0 .506.095.696.286l2.841 2.84a1 1 0 0 1-1.414 1.414zM12.5 11V9h-4a1 1 0 0 1 0 2zm2 0h5V9h-5zm-2 0h-5v10h12V11h-5v5.002a1 1 0 0 1-2 0zm7 0h-1a1 1 0 0 1 0-2h1z"
    />
  </svg>
);
export default SvgIconShare;
